<template>
	<article ref="toggleItemWrapper" :class="[
			'dc-post-grid-card person-card light-bg-theme has-shadow-mobile', 
			activeClass, 
			contentOpenClass
		]">
		<div class="toggle-wrapper">
			<div ref="toggleTriggerWrapper" class="person-overview toggle-title toggle-section-wrapper" @click.stop.prevent="toggle">
				<div v-if="photo" class="image-wrapper" v-html="photo"></div>
				<div v-if="image" class="image-wrapper">
					<img :src="image.src" :srcset="image.srcset" :alt="image.alt" />
				</div>
				<div class="content-wrapper">
					<h1 class="person-name">{{ name }}</h1>
					<h2 class="person-title">{{ title }}</h2>
					<h3 v-if="tag" class="person-tag">{{ tag }}</h3>
				</div>
				<div :class="['bio-link', {
					'has-tag': tag!==''
				}]">
					<a v-if="isExpanded" href="#" class="link read-more-link expand" @click.stop.prevent="toggle">
						<span class="screen-reader-text">Les mer</span>
					</a>
				</div>
			</div>
			<div v-if="isExpanded" ref="toggleContentWrapper" class="person-bio toggle-content toggle-section-wrapper">
				<dl v-if="hasUserContactInfo">
					<dt v-if="hrefEmail">Email</dt>
					<dd v-if="hrefEmail"><a :href="hrefEmail" :tabindex="toggledContentTabindex">{{ email }}</a></dd>
					<dt v-if="hrefTel">Tel</dt>
					<dd v-if="hrefTel"><a :href="hrefTel" :tabindex="toggledContentTabindex">{{ phone }}</a></dd>
					<dt v-if="linkedin">LinkedIn</dt>
					<dd v-if="linkedin"><a :href="linkedin" :tabindex="toggledContentTabindex">Go to</a></dd>
				</dl>
				<div v-if="bio" ref="toggleContentWrapperInner" v-html="bio"></div>
			</div>
		</div>
	</article>
</template>
<script>
import { Toggleable } from '@dc-post-grid/mixins/Toggleable';
export default {
	mixins: [Toggleable],
	data() {
		return {
			offsetHeightAdjustment: 119, // include any change in height on card for toggled state
		}
	},
	props: {
		id: {
			type: String | Number,
			required: true
		},
		'image': {
			type: Array,
			required: true
		},
		'photo': {
			type: String,
			required: true
		},
		'name': {
			type: String,
			required: true
		},
		'title': {
			type: String,
			required: false
		},
		'tag': {
			type: String,
			required: false
		},
		'email': {
			type: String,
			required: false
		},
		'phone': {
			type: String,
			required: false
		},
		'linkedin': {
			type: String,
			required: false
		},
		'bio': {
			type: String,
			required: false
		},
	},
	computed: {
		hasUserContactInfo() {
			return (this.phone || this.email || this.linkedin)
		},
		isExpanded() {
			return (this.bio || this.hasUserContactInfo)
		},
		hrefEmail() {
			return (this.email) ? 'mailto:' + this.email : false
		},
		hrefTel() {
			return (this.phone) ? 'tel:' + this.phone : false
		}
	}
}
</script>